import { mediaMax } from '@/app/styles/breakpoints'
import { Flex } from 'antd'
import styled from 'styled-components'

export const LoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('/images/login-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 20px;

  ${mediaMax.sm} {
    background: ${(props) => props.theme.colors.grayBackground};
    padding-left: 0;
    padding-right: 0;
  }
`

export const LoginCard = styled.div`
  width: 100%;
  max-width: 450px;
  background-color: ${(props) => props.theme.colors.grayBackground};
  box-shadow: 8px 16px 64px 0px rgba(5, 117, 186, 0.25);
  border-radius: 6px;
  padding: 48px;

  ${mediaMax.sm} {
    max-width: 100%;
    margin: 0 16px;
    box-shadow: none;
    padding: 0;
  }
`

export const LoginText = styled(Flex)`
  gap: 8px;
`

export const Logo = styled.img`
  height: 21px;
  width: 300px;
  object-fit: contain;
  align-self: center;
`
